// react component called Services for Terms and Services page

const Services = () => {
  return (
    <div style={{ backgroundColor: "white" }}>
      <h1>Terms and Conditions</h1>
      <p>
        *1. Introduction: Welcome to the Access Coordinator Boot Camp (ACBC)
        website, a 501(c)(3) non-profit organization dedicated to providing
        biologic and specialty medication education across multiple specialties
        to healthcare professionals. By accessing and using our website, you
        agree to the following terms and conditions.
      </p>
      <p>
        *2. Website Usage: The ACBC website is intended for educational purposes
        and to provide information about our non-profit organization and the
        services we offer. - Users are prohibited from using the website for any
        commercial or unlawful activities.
      </p>
      <p>
        *3. Non-Profit Status: ACBC is a registered 501(c)(3) non-profit
        organization committed to advancing healthcare education and supporting
        healthcare professionals in their ongoing learning and development.
      </p>
      <p>
        *4. Service Offerings: ACBC offers educational programs, workshops, and
        resources focused on biologic and specialty medication education in
        various specialties. - Participation in ACBC programs may be subject to
        specific eligibility criteria and registration requirements.
      </p>
      <p>
        *5. Intellectual Property: All content, materials, and resources
        provided on the ACBC website are the intellectual property of ACBC.
        Users are prohibited from reproducing or distributing this content
        without prior authorization.
      </p>
      <p>
        *6. Disclaimer of Liability: While ACBC strives to provide accurate and
        informative content on the website, we cannot guarantee the completeness
        or accuracy of all information. ACBC is not liable for any damages or
        losses resulting from the use of the website or the information provided
        therein.
      </p>
      <p>
        *7. Donations and Contributions: ACBC relies on donations and
        contributions from supporters to fund its educational programs and
        initiatives. Donations are voluntary and greatly appreciated.
      </p>
      <p>
        *8. Changes to Terms and Conditions: ACBC reserves the right to update
        or modify the terms and conditions of the website as needed. Users will
        be notified of any changes through the website.
      </p>
    </div>
  );
};
export default Services;
